const FirstProfile = {
    gender: null,
    profilePhotoUrl: null,
    firstName: null,
    lastName: null,
    nickName: null,
    facebook: null,
    lineId: null,
    mobileNumber: null,
    birthDate: null,
    age: null,
    email: null,
    homeNumber: null
};

const SecondProfile = {
    bloodType: null,
    religion: null,
    race: null,
    nationality: null,
    congenitalDisease: null,
    drugAllergy: '',
    foodAllergies: '',
    parent: null,
    relationshipWithParent: null,
    parentMobilePhoneNumber: null
};

const Address = {
    address: null,
    district: null,
    subDistrict: null,
    province: null,
    postalCode: null
};

const Education = {
    school: null,
    schoolProvince: null,
    major: null,
    currentStudyYear: null,
    gpa: null
};

const SurveyQuestion = [
    'รู้จักกับ LINE Messaging API รึเปล่าเเละเคยใช้ LINE chatbot ไหม ถ้าเคย เคยใช้ของอะไร (ตัวอย่าง chatbot: SCBAM, LINE ดูดวง, Wongnai)',
    'น้องคิดว่า chatbot น่าจะทำอะไรได้บ้างและ ถ้าน้องมีโอกาสทำ chatbot ของตัวเองน้องอยากทำแชทบอทที่เอาไว้ทำอะไร',
    'ให้น้อง ๆ แต่งเรื่องโดยใช้คำเหล่านี้มาแต่ง พร้อมวาดภาพประกอบ (pm2.5 / แง๊นๆ / เลื่อน / ลวก / แอดดริ๊งค์ / หมี่หยก / Ask real / เพลิงนวล / เลือกตั้ง / ก็มาดิครับ)',
    'แม่จ๋าช่วยหนูด้วย หนูกินกล้วยอยู่บนหลังคา ตกลงมาทายาหม่อง 20 กล่องก็ไม่หาย พี่อยากรู้ว่าทำไมทาตั้ง 20 กล่องก็ยังไม่หายและต้องทำอย่างไรถึงจะหาย',
    'น้อง ๆ คิดว่าตัวเองจะได้อะไรกลับไปบ้างหลังจากมาค่ายนี้',
    'ให้น้อง Present ความเป็นตัวน้อง ว่าทำไมพี่ถึงต้องให้น้องมาเข้าค่ายนี้',
    'น้องเคยเข้าร่วมค่ายในโครงการอื่นบ้างหรือไม่ (ไม่รวมค่ายลูกเสือ-เนตรนารี จริยธรรมและค่าย ร.ด.)',
    'น้องทราบข่าวค่าย Hypercube 28 จากทางใด'
];

const Survey = {
    lineBotKnowledge: null,
    lineBotOpinion: null,
    storyContent: null,
    storyPhotoUrl: null,
    stupidQuestion: null,
    expectation: null,
    selfPresentation: null,
    wasParticipatedInCamp: false,
    participatedCamp: '',
    awarenessSource: null
};

const loremIpsum = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

const mockSurvey = Object.create(Survey);
mockSurvey.lineBotKnowledge = 'lineBotKnowledgeAnswer ' + loremIpsum;
mockSurvey.lineBotOpinion = 'lineBotOpinionAnswer ' + loremIpsum;

mockSurvey.storyContent = 'meowmeowmeowmeowmeowmeow ' + loremIpsum;
mockSurvey.storyPicture = 'mockUrl ';

mockSurvey.stupidQuestion = 'stupidstupidstupid ' + loremIpsum;
mockSurvey.expectation = 'expectationAns ' + loremIpsum;

mockSurvey.wasParticipatedInCamp = true;
mockSurvey.participatedCamp = 'campExperience' + loremIpsum;

mockSurvey.selfPresentation = 'selfPresentationAns' + loremIpsum;
mockSurvey.awarenessSource = 'Facebook page';

const mockData = {
    gender: 'นาย',
    firstName: 'อรุษ',
    lastName: 'จินะดิษฐ์',
    nickName: 'ปลาย',
    facebook: 'Arut Jinadit',
    lineId: 'arut-id',
    mobileNumber: '0816413661',
    birthDate: new Date(),
    age: 21,
    email: '60090002@kmitl.ac.th',
    homeNumber: '0816413661',

    bloodType: 'A',
    religion: 'คริสต์',
    race: 'ไทย',
    nationality: 'ไทย',
    congenitalDisease: 'ไม่มี',
    drugAllergy: 'ไม่มี',
    foodAllergies: 'ไม่มี',
    parent: 'รณชิต จินะดิษฐ์',
    relationshipWithParent: 'บิดา',
    parentMobilePhoneNumber: '0897674222',

    address: '94/154 ซ.วัชรพล 1/3 ถนนวัชรพล',
    district: 'บางเขน',
    subDistrict: 'ท่าเเร้ง',
    province: 'กรุงเทพ',
    postalCode: '10220',

    school: 'มัธยมสาธิตมหาวิิทยาลัยนเรศวร',
    schoolProvince: 'พิษณุโลก',
    major: 'วิทย์/คณิต',
    currentStudyYear: 'ม.6 (ขึ้น ปี 1)',
    gpa: 3.26,

    ...mockSurvey
};

const errorText = {
    gender: 'กรุณาระบุเพศ',
    firstName: 'กรุณากรอกชื่อจริง',
    lastName: 'กรุณากรอกนามสกุล',
    nickName: 'กรุณากรอกชื่อเล่น',
    facebook: 'โปรดระบุ facebook',
    lineId: 'โปรดระบุ LINE ID',
    mobileNumber: 'โปรดระบุเบอร์โทรศัพท์มือถือ',
    birthDate: 'โปรดเลือกวันเกิด',
    age: 'โปรดกรอกอายุ',
    email: 'โปรดกรอกอีเมล์',
    homeNumber: 'โปรดกรอกเบอร์โทรศัพท์บ้าน',

    bloodType: 'โปรเลือกกรุ๊ปเลือก',
    religion: 'โปรดกรอกศาสนา',
    race: 'โปรดกรอกเชื้อชาติ',
    nationality: 'โปรดกรอกสัญชาติ',
    congenitalDisease: null,
    drugAllergy: null,
    foodAllergies: null,
    parent: 'โปรดกรอกชื่อผู้ปกครอง',
    relationshipWithParent: 'โปรดระบุความสัมพันธ์กับผู้ปกครอง',
    parentMobilePhoneNumber: 'โปรดกรอกเบอร์โทรศัพท์ผู้ปกครอง',

    address: 'โปรดกรอกที่อยู่',
    district: 'โปรดกรอกอำเภอหรือเขต',
    subDistrict: 'โปรดกรอกตำบลหรือเเขวง',
    province: 'โปรดกรอกจังหวัด',
    postalCode: 'โปรดกรอกรหัสไปรษณีย์',

    school: 'โปรดกรอกชื่อโรงเรียน',
    schoolProvince: 'โปรดกรอกจังหวัดของโรงเรียน',
    major: 'โปรดเลือกแผนการเรียน',
    currentStudyYear: 'โปรดเลือกปีการศึกษา',
    gpa: 'โปรดระบุเกรดเฉลี่ย',

    lineBotKnowledge: 'กรุณาตอบคำถามที่ 1',
    lineBotOpinion: 'กรุณาตอบคำถามที่ 2',
    storyContent: 'กรุณาตอบคำถามที่ 3',
    // storyPhotoUrl: 'กรุณาอัพโหลดรูปที่มาจากเรื่องแต่ง',
    stupidQuestion: 'กรุณาตอบคำถามที่ 4',
    expectation: 'กรุณาตอบคำถามที่ 5',
    selfPresentation: 'กรุณาตอบคำถามที่ 6',
    wasParticipatedInCamp: null,
    participatedCamp: 'กรุณากรอกค่ายที่เคยเข้า',
    awarenessSource: 'กรุณากรอกคำถามที่ 8'
};

const User = {
    ...FirstProfile,
    ...SecondProfile,
    ...Address,
    ...Education,
    ...Survey
};

export {
    User,
    mockData,
    errorText
}
